/**
 * The short gold dash under a header's title and sub (MVP `.hm-drawer-head::after`, 28×1.5px).
 * Shared by AdaptiveDrawer's sticky header, AddressSuggestionDrawer and CranePageHeader so the
 * rule matches on drawers and full page forms (TK-13348). Each header adds its own top margin so
 * the dash sits 14px under the sub; the bottom margin is part of the rule.
 */
export const HEADER_GOLD_RULE_CLASS = 'mb-2 h-[0.09375rem] w-7 shrink-0 bg-(--gold)'
